import { useRosterState } from "amazon-chime-sdk-component-library-react";
import { useTranscription } from "../../../video/providers/TranscriptionProvider";
import VideoUIControlsTranscription from "./VideoUIControlsTranscription";

export function VideoUIControlsTranscriptionContainer() {
  const { state, toggleTranscription } = useTranscription();

  const { roster } = useRosterState();

  const attendeeCount = Object.keys(roster).length;

  if (state.isTranscriptionDisabled) {
    return null;
  }

  if (attendeeCount <= 1) {
    return null;
  }

  return (
    <VideoUIControlsTranscription
      isTranscribing={state.isTranscribing}
      onClick={toggleTranscription}
    />
  );
}

export default VideoUIControlsTranscriptionContainer;
